const menuPhotocode = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
        <g stroke="#F5F5F5" stroke-linecap="round" stroke-linejoin="round">
          <rect width="5.25" height="5.25" x=".379" y=".375"/>
          <rect width="2.25" height="2.25" x="1.879" y="1.875"/>
          <rect width="5.25" height="5.25" x=".379" y="12.375"/>
          <rect width="2.25" height="2.25" x="1.879" y="13.875"/>
          <rect width="2.25" height="2.25" x="12.379" y="12.375"/>
          <rect width="5.25" height="5.25" x="12.379" y=".375"/>
          <rect width="2.25" height="2.25" x="13.879" y="1.875"/>
          <path d="M9.75375,7.125 L7.12875,7.125"/>
          <polyline points="7.129 8.625 7.129 10.875 9.754 10.875"/>
          <polyline points=".379 7.125 5.629 7.125 5.629 8.625"/>
          <polyline points="16.875 10.875 16.875 7.125 17.629 7.125"/>
          <path d="M15.375,8.625 L15.375,10.875"/>
          <polyline points="15.004 7.125 11.625 7.125 11.625 8.625"/>
          <polyline points="9.379 3.375 9.379 4.875 10.879 4.875 10.879 1.875"/>
          <path d="M7.12875 5.625L7.12875 3.375M8.62875.375L10.87875.375"/>
          <polyline points="7.129 .375 7.129 1.875 8.629 1.875"/>
          <path d="M1.87875,9.375 L4.12875,9.375"/>
          <polyline points=".379 8.625 .379 10.875 1.879 10.875"/>
          <polyline points="9.379 17.625 16.129 17.625 16.129 12.375 17.629 12.375 17.629 14.625"/>
          <polyline points="7.129 13.125 7.129 16.125 9.379 16.125"/>
          <polyline points="14.629 16.125 10.879 16.125 10.879 14.25"/>
          <polyline points="8.625 14.625 8.625 12.375 10.879 12.375"/>
          <path d="M4.12875 10.875L5.62875 10.875M9.75375 8.625L8.25375 8.625M11.625 10.875L13.875 10.875M13.125 10.875L13.125 9.375"/>
        </g>
        <rect width="18" height="18"/>
      </g>
    </svg>

`;

export default menuPhotocode;
